// Global route-change scroll-restoration helper.
// Every time the pathname changes (route navigation via Link / navigate() etc.)
// this resets the window scroll position to the top. Hash-based anchor navigation
// on the SAME page is left untouched so #modules, #contact etc still work.
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Allow the browser to smooth-scroll to the anchor after mount.
      const id = hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        // Defer so the destination view has mounted.
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 100);
        return;
      }
    }
    // No hash — always scroll to top for a fresh page/section start.
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash]);

  return null;
}
